'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { Component } from 'react';
import ReactCodeMirror from 'react-codemirror';
import styled from 'styled-components';
import UIExpandableText, { EXPANDABLE_TEXT_HEIGHT_OFFSET } from 'UIComponents/text/UIExpandableText';
const StyledWrapper = styled.div.withConfig({
  displayName: "CodeMirror__StyledWrapper",
  componentId: "sc-1i0a1wu-0"
})(["button{padding-left:10px;}"]);
export default class CodeMirror extends Component {
  constructor(...args) {
    super(...args);

    this.refCodemirror = ref => {
      this.codemirror = ref && ref.codemirror;
    };

    this.renderCodeMirror = () => {
      return /*#__PURE__*/_jsx(ReactCodeMirror, Object.assign({
        theme: "hubspot-canvas-dark",
        width: "100%",
        lineWrapping: true,
        readOnly: true,
        refCodemirror: this.refCodemirror
      }, this.props));
    };
  }

  componentDidMount() {
    this.codemirror.refresh();
  }

  render() {
    return /*#__PURE__*/_jsx(StyledWrapper, {
      children: this.props.collapsible ? /*#__PURE__*/_jsx(UIExpandableText, {
        use: "on-dark",
        maxHeight: 400 + EXPANDABLE_TEXT_HEIGHT_OFFSET,
        expandButtonText: I18n.text('developer-docs-shared-components.params.body.newExpandButton'),
        collapseButtonText: I18n.text('developer-docs-shared-components.params.body.newCollapseButton'),
        buttonAlign: "left",
        gradientColor: "transparent",
        children: this.renderCodeMirror()
      }) : this.renderCodeMirror()
    });
  }

}
CodeMirror.propType = {
  height: PropTypes.string,
  mode: PropTypes.string,
  value: PropTypes.string,
  collapsible: PropTypes.boolean
};
CodeMirror.defaultProps = {
  height: 'auto'
};